import React, {useEffect, useState} from 'react';
import GoBack from "../../subsidiary/GoBack/GoBack";
import copySVG from '../../../assets/img/copyIcon.svg'
import Button from "@mui/material/Button";
import {Tooltip} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import Loader from "../../subsidiary/Loader/Loader";

const SuccessPage = () => {
    const [isCopyed, setIsCopyed] = useState(false)
    const someStuff = useSelector(state => state.eventSlice.userNumberLoading)
    const userNum = useSelector(state => state.eventSlice.userNumber)
    const id = userNum
    const copy = () => {
        navigator.clipboard.writeText(id)
            .then(() => setIsCopyed(true))

    }

    return (
        <>
            {!userNum ? <Loader /> :
        <div className='content-wrapper'>
            <GoBack nav='/event/about' text='Новогодний розыгрыш'/>
            <h1 className='apply_title'>
                Успешно!
            </h1>
            <div className='success_container'>
                <span className='success_first-par'>Ваша заявка успешно отправлена!</span>
                <div className='condition_second-body'>
                    <span className='user_number'>Ваш номер участника</span>
                    <div className='condition_second-body' style={{display: "flex", alignItems: "center"}}>
                        <button className='copy_button'>
                            {userNum}
                            {/*{loading ? <Loader/> : localStorage.getItem('user_number')}*/}
                        </button>
                        <Tooltip title={isCopyed ? 'Скопировано!' : ''}>
                            <img onClick={copy} src={copySVG} alt=""/>
                        </Tooltip>
                    </div>

                </div>
            </div>
        </div>
            }
        </>
    );
};

export default SuccessPage;